var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Small_Icons",
    "data-name": "Small Icons",
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #fff;\n        stroke-linecap: round;\n        stroke-width: 3px;\n      }\n\n      .cls-1, .cls-2 {\n        fill-rule: evenodd;\n      }\n\n      .cls-2 {\n        fill: #fff;\n        opacity: 0.25;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "close"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rounded_Rectangle_17_copy_4",
    "data-name": "Rounded Rectangle 17 copy 4",
    className: "cls-1",
    d: "M10.974,5.672L44.328,39.026c1.425,1.425,1.689,3.47.591,4.568L43.594,44.92c-1.1,1.1-3.144.834-4.568-.591L5.672,10.974C4.247,9.55,3.982,7.5,5.08,6.406L6.406,5.08C7.5,3.982,9.55,4.247,10.974,5.672Zm33.272,5.362L11.034,44.246c-1.419,1.419-3.455,1.682-4.549.589l-1.32-1.32c-1.094-1.094-.83-3.13.589-4.549L38.966,5.754c1.419-1.419,3.455-1.682,4.549-.589l1.32,1.32C45.929,7.579,45.665,9.615,44.246,11.034Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M-21,23m41,3L41,15,31,25,46,41l-2,4H41L25,31,10,46H6L4,42Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.2abe7b24549a4b087795f6e4ba32f21b.svg";
export { ForwardRef as ReactComponent };